import * as React from 'react'
/// import { ApolloProvider, Query } from 'react-apollo'
import { ApolloProvider } from '@apollo/client'
import { Query } from '@apollo/client/react/components'
import { BrowserRouter as Router } from 'react-router-dom'
import { Store } from './models/store'
import { ME_QUERY } from './queries/ME_QUERY'
import  AuthRoutes from './routes/AuthRoutes'
import { GuestRoutes } from './routes/GuestRoutes'
import { MeQuery } from './schema/schemaTypes'
import './styles/bootstrap-reboot.css'
import './styles/fonts.css'
import { apolloClient } from './utils/apolloClient'

class App extends React.Component<{ store: typeof Store.Type }, object>{

  public componentDidMount(): void {
    if (window.location.href.includes('webinfoes')) {
      document.title = 'L-WebINFO'
    }else if (window.location.href.includes('lwebinfo')) {
      document.title = 'L-WebINFO'
    }else if (window.location.href.includes('webinfo')) {
      document.title = 'WebINFO'
    }
  }

  public render() {

    return (
      <Router>
        <ApolloProvider client={apolloClient}>

          <Query<MeQuery> query={ME_QUERY}>
            {({ data, loading, error }) => {
              if (loading) { return null }
              if (error) { return <p>Error :(</p> }
              if (data && data.me && data.me.id) { return <AuthRoutes userType={data.me.userType}/> }
              return <GuestRoutes />
            }}
          </Query>
         </ApolloProvider>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.tsx